import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/report_form/predit/month',
    method: 'get',
    params
  })
}
// 筛选条件列表
export function getSelectList() {
  return request({
    url: '/novel_management/novel_report_selects',
    method: 'get'
  })
}
